// Sunucudan gelen dosyayı kullanıcıya indirtir.
//
// Biçimlendirilmiş Excel (renkler, kenarlıklar, sütun genişlikleri, başlık şeridi) SUNUCUDA
// üretiliyor — CSV bunları taşıyamıyordu, tarayıcı tarafında üretmek için gereken kütüphane
// ise uygulama paketini iki katına çıkarırdı (kullanıcı talebi: 2026-09-03).
//
// Kullanımı:
//   const yanit = await getCallCenterExcel(params);   // responseType: 'blob'
//   dosyaIndir(yanit);
export function dosyaIndir(yanit, varsayilanAd = 'liste.xlsx') {
  const ad = adCikar(yanit) || varsayilanAd;
  const url = URL.createObjectURL(yanit.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = ad;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Dosya adı sunucunun Content-Disposition başlığından okunur; okunamazsa varsayılan kullanılır.
const adCikar = (yanit) => {
  const basli = yanit?.headers?.['content-disposition'];
  if (!basli) return null;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(basli);
  if (utf8) return decodeURIComponent(utf8[1]);
  const duz = /filename="?([^";]+)"?/i.exec(basli);
  return duz ? duz[1] : null;
};

// Hata gövdesi de blob olarak geldiği için, mesajı okumak adına metne çevrilmesi gerekir.
export async function blobHatasiOku(err) {
  const veri = err?.response?.data;
  if (veri instanceof Blob) {
    try {
      const metin = await veri.text();
      return JSON.parse(metin)?.hata || null;
    } catch {
      return null;
    }
  }
  return veri?.hata || null;
}
